import {StorageKey} from "../../../../enums/StorageKey";
import {t} from "@lingui/macro";

export default {
    storageKey: StorageKey.report_sales_by_customer,
    getReportLabel: () => t`Sales Summary by Customer`,
    getColumns: () => [],
};
